export enum ActionToolbar {
    fill = 'fill',
    split = 'split',
    changeView = 'changeView',
    resetExtent = 'resetExtent',
    toogleProjection = 'toogleProjection',
    orientation = 'orientation',
    namedViews = 'namedViews',
    vr = 'vr',
    frontImage = 'frontImage',
    previous = 'previous',
    next = 'next',
    inspectLocation = 'inspectLocation',
    multiSegment = 'multiSegment',
    flip = 'flip',
    scale = 'scale',
    information = 'information',
    measure = 'measure',
    buffer = 'buffer',
    annotation = 'annotation',
    layerEdition = 'layerEdition',
    saveview = 'saveview',
    screenshot = 'screenshot',
    pointEdition = 'pointEdition',
    crViews = 'crViews',
    drawingRule = 'drawingRule',
    visibility = 'visibility',
    vrPanorama = 'vrPanorama',
    view_3D = 'view_3D',
    view_map = 'view_map',
    view_section = 'view_section',
    view_table = 'view_table',
    view_gallery = 'view_gallery',
    timeline = 'timeline',
    '3dPerspective' = '3dPerspective',
    ortho = 'ortho',
    floormap = 'floormap',
    top_view = 'top_view',
    bottom_view = 'bottom_view',
    front_view = 'front_view',
    back_view = 'back_view',
    left_view = 'left_view',
    right_view = 'right_view',
    isometric_view = 'isometric_view',
    tools = 'tools',
    virtualTour = 'virtualTour',
    resetExtentSitesMap = 'resetExtentSitesMap',
}

export type ActionToolbarString = keyof typeof ActionToolbar;
